const ENSector = {
	"Adicionar setor": "Add sector",
	"Alterar setor": "Change sector",
	"Criar novo setor": "Create new sector",
	"Deseja realmente excluir o setor": "Do you really want to delete the sector",
	"Erro ao adicionar setor": "Error on adding sector",
	"Erro ao alterar setor": "Error on changing sector",
	"Erro ao excluir setor": "Error on deleting sector",
	"Exclusão do setor": "Delete sector",
	"Descrição do setor é requerida": "Sector's description is required",
	"Novo setor": "New sector",
	"Setor": "Sector",
	"Setor adicionado com sucesso": "Sector successfully added",
	"Setor alterado com sucesso": "Sector successfully changed",
	"Setor excluído com sucesso": "Sector successfully deleted",
	"Setores": "Sectors"
};

export default ENSector;
